export const VERSION = "v2.1.1410";
export const EXT_TITLE = "Mass Profiler UI";